<script>
	import { AppContext } from './Context.svelte.js';

	/** @type {{ entry: import('./types.d.ts').LegislatorEntry }} */
	let { entry } = $props();

	let ctx = AppContext.get();

	/**
	 * @param {import("./types.d.ts").DataRecord} bill
	 */
	function handleTouch(bill) {
		/**
		 * @param {HTMLElement} element
		 */
		return (element) => {
			/**
			 * @param {TouchEvent} e
			 */
			const listener = (e) => {
				e.preventDefault();
				ctx.isTouchDevice = true;
				ctx.tooltip.mouseover(bill);
			};
			element.addEventListener('touchstart', listener, { passive: false });
			return () => {
				element.removeEventListener('touchstart', listener);
			};
		};
	}
</script>

<div class="g-row">
	<div class="g-name">
		{entry.legislator} ({entry.party.charAt(0)})
	</div>
	<div class="bill-container">
		{#each entry.bills as bill}
			<a
				{@attach handleTouch(bill)}
				class="bill"
				href={bill.bill_url}
				target="_blank"
				rel="noreferrer"
				aria-label="{bill.bill}: {bill.bill_description}"
				{...ctx.tooltip.selectionProps(bill)}
				ontouchstart={(e) => {
					e.preventDefault();
					ctx.isTouchDevice = true;
					ctx.tooltip.mouseover(bill);
				}}
			>
				<div class="overlay"><div>{bill.vote}</div></div>
			</a>
		{/each}
	</div>
</div>

<style>
	.bill .overlay {
		width: 100%;
		display: inline-block;
		content: ' ';
		background-color: transparent;
		height: 100%;
		position: absolute;
		border-top-right-radius: 33%;
		pointer-events: all;
	}

	.bill:hover .overlay {
		background-color: rgba(0, 0, 0, 0.1);
	}

	.bill .overlay div {
		text-align: center;
		font-size: 12px;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 100%;
	}

	.bill {
		float: left;
		position: relative;
		margin: 0 0.16em 0.16em;
		cursor: pointer;
		background-image: url('https://s3.amazonaws.com/vpap-production/media/visuals/images/bill-icon-1.png');
		background-size: 100%;
		background-repeat: no-repeat;
		width: 30px;
		height: calc(30px * 1.2 + 2px);
	}

	.bill:last-child {
		margin-right: 0;
	}

	.g-row {
		align-items: center;
		margin: 0.35em 0;
		padding: 0.75em 0 0.35em;
		border-top: 1px solid #eee;
		display: grid;
		grid-template-columns: 50% auto;
	}

	@media (min-width: 768px) {
		.g-row {
			grid-template-columns: 1fr 2fr;
		}
	}

	@media (min-width: 992px) {
		.g-row {
			grid-template-columns: 20% auto;
		}
	}

	.g-name {
		font-size: 0.9375rem;
	}

	a {
		color: inherit;
		text-decoration: none; /* Optional: removes default underline */
	}

	@media (min-width: 800px) {
		.bill {
			width: 30px;
			height: calc(30px * 1.2 + 2px);
		}
	}
</style>
